import { BASE_URL } from './Constants';

export const GET_SERVICE_LIST = `${BASE_URL}api/Appointment/GetServices`;
export const GET_SERVICES_BY_DOCTOR = `${BASE_URL}api/external/Common/GetDoctorServices`;
